export const fmtPrice = (n) => (n == null ? '—' : n.toFixed(2));
export const fmtPct = (n) => (n == null ? '—' : `${n >= 0 ? '+' : ''}${n.toFixed(2)}%`);
export const fmtInt = (n) => (n == null ? '—' : new Intl.NumberFormat('en-US').format(Math.round(n)));
export const fmtVol = (n) => {
  if (n == null) return '—';
  if (n >= 1e9) return (n / 1e9).toFixed(2) + 'B';
  if (n >= 1e6) return (n / 1e6).toFixed(2) + 'M';
  if (n >= 1e3) return (n / 1e3).toFixed(1) + 'K';
  return String(n);
};
export const colorForPct = (n) => (n == null ? 'var(--muted)' : n > 0 ? 'var(--up)' : n < 0 ? 'var(--down)' : 'var(--muted)');
